import type { PlayerState, Role, Team } from '@shared/types';
import { SERVER_TICK_MS } from '@shared/constants';
import type { SocketClient } from './SocketClient';
import type { FlightController } from '../game/FlightController';

// ============================================================
// Sends local player state to server at tick rate (20Hz)
// ============================================================

export class StateEmitter {
  private interval: ReturnType<typeof setInterval> | null = null;

  constructor(
    private readonly socketClient: SocketClient,
    private readonly flightController: FlightController,
    private readonly role: Role,
    private readonly team: Team,
    private readonly username: string,
  ) {}

  start(): void {
    if (this.interval) return;

    this.interval = setInterval(() => {
      if (!this.socketClient.connected) return;

      const mesh = this.flightController.mesh;
      const state: PlayerState = {
        id: this.socketClient.id,
        username: this.username,
        team: this.team,
        role: this.role,
        position: {
          x: mesh.position.x,
          y: mesh.position.y,
          z: mesh.position.z,
        },
        rotation: {
          x: mesh.rotation.x,
          y: mesh.rotation.y,
          z: mesh.rotation.z,
        },
        velocity: this.flightController.velocity,
        alive: true,
        health: 100,
        isFiring: this.flightController.isFiring,
      };

      this.socketClient.sendState(state);
    }, SERVER_TICK_MS);
  }

  stop(): void {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}
